var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1,20.6l-6.5-11.1-6.5,11.1c-.7,1.2-1.1,2.6-1,4,0,1.9.9,3.7,2.2,5.1.9.9,2.5,2.1,5,2.1h.3s.3,0,.3,0c2.4,0,4-1.2,5-2.1,1.3-1.3,2.1-3.2,2.2-5.1,0-1.4-.3-2.8-1-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,28.1c-.7.7-1.8,1.5-3.5,1.5h-.5c-1.7,0-2.8-.9-3.5-1.5-1-1-1.5-2.3-1.6-3.6,0-1,.2-2,.7-2.9l4.6-7.9,4.6,7.9c.5.9.8,1.9.7,2.9,0,1.4-.6,2.7-1.6,3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/Drop.b01614cf1cc3cc2e5664ed529c3d2613.svg";
export { ForwardRef as ReactComponent };